import React, { Component, createElement } from 'react'
import { connect } from 'react-redux'
import { labelsRequest } from 'store/actions'
import { translationType } from 'common/types'
import labels from 'common/labels'
import axios from 'axios'
import { camelCase, isFunction } from 'lodash'

export const filters = {
  clean: e => e?.replace(/<\/?.+?>/g, ''),
  colon: e => e?.replace(/:?$/, ':'),
  noColon: e => e?.replace(':', ''),
  br: e => e.split(/(<br ?\/?>)/).map((e, i) => (i % 2 ? <br /> : e)),
  basicHTML: text => {
    const items = (text = text
      .replace('&mdash;', '—')
      .replace('&ndash;', '–')
      .split(/<strong.*?>(.*)<\/strong>/))
    return items.map((e, i) => (i % 2 ? <strong key={i}>{e}</strong> : e))
  },
}

const wait = time => new Promise(resolve => setTimeout(resolve, time * 1000))
const fetch = (locale, i) =>
  wait(i)
    .then(() => axios(labelsRequest(locale)))
    .then(r => ({ locale, data: r.data }))

if (process.env.NODE_ENV !== 'test') {
  window.usedLabels = {}
  window.allLabels = Object.values(labels)
    .map(Object.values)
    .reduce((a, b) => a.concat(b))
  window.checkMissingLabels = async (labels = Object.keys(window.usedLabels)) => {
    const locales = 'cs da de es fr hr it lt hu nl no pl pt sk sr fi sv tr el ru ar th ja'.split(' ')
    const missing = (window.missing = {})
    const translations = (window.translations = {})

    const en = (translations.en = (await fetch('en')).data)
    const languages = await wait(2).then(() => axios.all(locales.map(fetch)))

    languages.forEach(({ locale, data }) => {
      translations[locale] = data
      missing[locale] = Object.keys(data).filter(key => labels.includes(key) && data[key] == en[key])
    })
    console.warn(missing)
  }
}
const macroRegex = /\{%(.*?)%\}/g

class T extends Component {
  logLabel = ({ name, translations } = this.props) => (window.usedLabels[name] = translations[name]);

  componentDidMount() {
    this.props.flags.logUsedLabels && this.logLabel()
  }
  componentDidUpdate(props) {
    this.props.flags.logUsedLabels > props.flags.logUsedLabels && this.logLabel()
  }

  replaceMacros = (str = '', macros, props) => {
    str = str.replace(macroRegex, (e, g) => {
      const name = camelCase(g),
        macro = macros[name]
      !macros[name] && console.warn(`Macro ${e} (${name}) not provided for: ${str}`)
      return isFunction(macro) ? `{%${name}%}` : macro
    })

    const items = str.split(macroRegex)
    if (items.length == 1) {
      return str
    }
    return items.map((e, i) => (i % 2 == 0 ? e : macros[e]({ label: str, key: str, ...props })))
  };

  render() {
    let { label, translations, macros, flags, as, ...props } = this.props
    let [name, filter] = (label.includes('/') ? label : `generalLabels/${label}`).split('|')
    let translation = translations[name]

    if (flags.showLabelNames) {
      !translation && console.error(`LABEL NOT FOUND - ${name} (${labels[name] || '__NOT_FOUND__'})`)

      return <span title={`${name} (${labels[name] || '__NOT_FOUND__'})`}>LL.{name.split('/').pop()}</span>
    }
    let value = this.replaceMacros(translation, macros, props)

    if (filter == 'unsafe') {
      return createElement(as || 'span', { ...props, dangerouslySetInnerHTML: { __html: value } })
    }
    if (filter) {
      value = !Array.isArray(value)
        ? filters[filter](value)
        : value.map(e => (typeof e == 'string' ? filters[filter](e) : e))
    }
    return as ? createElement(as, props, value) : value
  }
}

T.propTypes = translationType

const ConnectedT = connect(({ translations, flags }) => ({ translations, flags }), {})(T)

export const Membership = ({ user, ...props }) => (
  <ConnectedT label={`membership/${user.vip ? 'vip' : user.gold ? 'gold' : 'trial'}`} {...props} />
)

const intervals = [
  ['day', 86400],
  ['hour', 3600],
  ['minute', 60],
  ['second', 1],
]
export const timeSince = timestamp => {
  const seconds = ((Date.now() - timestamp) / 1000) | 1
  const [name, period] = intervals.find(e => seconds / e[1] >= 1)
  const value = Math.floor(seconds / period)

  return name === 'day' && value === 1 ? [null, 'yesterday'] : [value, `${name}sAgo`]
}

export const Time = ({ timestamp }) => {
  const [value, timeAgo] = timeSince(timestamp)
  return (
    <>
      {value} <ConnectedT label={timeAgo} />
    </>
  )
}

export default ConnectedT
